export const transformPercentToFloat = (percent: number): number => {
  return parseFloat((percent / 100).toFixed(2))
}
